import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.html',
    styleUrls: ['./help-dialog.scss']
})
export class HelpDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<HelpDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onClose(): void {
        this.dialogRef.close();
    }
}
